import { Link } from "react-router-dom";
import { ChevronRight, Plus } from "lucide-react";

export const Breadcrumbs = ({ items, dark }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-8">
    <ol className={`flex flex-wrap items-center gap-1.5 text-xs ${dark ? "text-slate-600" : "text-slate-600"}`}>
      {items.map((c, i) => (
        <li key={c.to} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="h-3 w-3" />}
          {i < items.length - 1 ? <Link to={c.to} className={dark ? "hover:text-white" : "hover:text-slate-900"}>{c.label}</Link> : <span aria-current="page" className={dark ? "text-white" : "text-slate-900"}>{c.label}</span>}
        </li>
      ))}
    </ol>
  </nav>
);

export const FaqList = ({ faqs, id = "faq" }) => (
  <div className="divide-y divide-slate-200 border-y border-slate-200">
    {faqs.map((f, i) => (
      <details key={f.q} data-testid={`${id}-item-${i}`} className="group py-1">
        <summary className="flex cursor-pointer items-center justify-between gap-6 py-5 font-display text-base font-semibold text-slate-900 sm:text-lg">
          {f.q}
          <Plus className="faq-icon h-5 w-5 shrink-0 text-blue-600 transition-transform duration-300" />
        </summary>
        <p className="pb-6 pr-10 text-[15px] leading-relaxed text-slate-600">{f.a}</p>
      </details>
    ))}
  </div>
);

export const PageHero = ({ crumbs, eyebrow, title, intro, children }) => (
  <section className="bg-p-hero relative overflow-hidden text-slate-700">
    <div className="grid-bg pointer-events-none absolute inset-0 [mask-image:linear-gradient(to_bottom,black,transparent)]" />
    <div className="wrap relative pb-14 pt-8 sm:pb-20 sm:pt-12">
      {crumbs && <Breadcrumbs items={crumbs} />}
      {eyebrow && <p className="eyebrow anim-in">{eyebrow}</p>}
      <h1 className="anim-in d-1 mt-4 max-w-4xl text-4xl font-extrabold leading-[1.02] text-[#0B1437] sm:text-5xl lg:text-6xl">{title}</h1>
      {intro && <p className="anim-in d-2 mt-5 max-w-2xl text-base leading-relaxed text-slate-700 md:text-lg">{intro}</p>}
      {children && <div className="anim-in d-3 mt-8 flex flex-wrap gap-3">{children}</div>}
    </div>
  </section>
);

export const SectionHead = ({ eyebrow, title, intro, center }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && <p className="eyebrow">{eyebrow}</p>}
    <h2 className="h-section mt-4">{title}</h2>
    {intro && <p className="lead-text mt-5">{intro}</p>}
  </div>
);
